import { render, staticRenderFns } from "./LookKPI.vue?vue&type=template&id=0a6442da&scoped=true&"
import script from "./LookKPI.vue?vue&type=script&lang=js&"
export * from "./LookKPI.vue?vue&type=script&lang=js&"
import style0 from "./LookKPI.vue?vue&type=style&index=0&id=0a6442da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6442da",
  null
  
)

export default component.exports